class StaticHelper {
  static isStripeInited: boolean = false
  static stripe: any;
}

export { StaticHelper }